import { render, staticRenderFns } from "./RecommendHistory.vue?vue&type=template&id=7c3a4e06&"
import script from "./RecommendHistory.vue?vue&type=script&lang=js&"
export * from "./RecommendHistory.vue?vue&type=script&lang=js&"
import style0 from "./RecommendHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports